'use client'

import { type SyntheticEvent, useState } from 'react'
import { default as NextImage, type ImageProps } from 'next/image'
import { clsx } from 'clsx'
import { DEFAULT_IMAGE_QUALITY } from '@/utils/config'
import { imageStyles } from './ImageWithPlaceholder.css'

type ImageWithPlaceholderProps = Omit<ImageProps, 'priority'> & { imagePriority?: boolean }

export const ImageWithPlaceholder = ({
  quality,
  className,
  onLoad,
  imagePriority,
  ...forwardedProps
}: ImageWithPlaceholderProps) => {
  const [hasLoaded, setHasLoaded] = useState(false)

  const handleLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    setHasLoaded(true)
    onLoad?.(event)
  }

  return (
    <NextImage
      {...forwardedProps}
      loading={imagePriority ? 'eager' : forwardedProps.loading}
      fetchPriority={imagePriority ? 'high' : forwardedProps.fetchPriority}
      quality={quality ?? DEFAULT_IMAGE_QUALITY}
      className={clsx(hasLoaded ? imageStyles.loaded : imageStyles.base, className)}
      onLoad={handleLoad}
    />
  )
}
